import {
  PayNowAuthorizationFailure,
  PayNowAuthorizationSucess,
} from 'client/Interfaces/PayNow/AccountAuthorizationParams'

import { Config } from '../../config'
import { StateInterface } from '../../Interfaces/StateInterface'
import { MyPayNowProps } from '../MyAccount/views/MyPayNow'

const STRIPE_OAUTH_URL = 'https://connect.stripe.com/oauth/authorize?response_type=code&scope=read_write'
const CSRF_TOKEN_KEY = 'zervat-oauth-csrf'

export const PayNowHelper = {
  buildOAuthUrlFromState(state: StateInterface): string {
    const params = mapStateToStripeParams(state)
    let url = STRIPE_OAUTH_URL
    url += addParam('client_id', Config.getStripeConnectId())
    url += addParam('stripe_user[email]', params.company.email)
    url += addParam('stripe_user[url]', params.url)
    url += addParam('stripe_user[country]', params.company.country)
    url += addParam('stripe_user[business_name]', params.name)
    url += addParam('stripe_user[first_name]', params.firstName)
    url += addParam('stripe_user[last_name]', params.lastName)
    url += addParam('stripe_user[street_address]', params.address)
    url += addParam('stripe_user[city]', params.city)
    url += addParam('stripe_user[zip]', params.zip)

    return url
  },
  addRedirectParamToUrl(url: string, originUrl: string) {
    const { protocol, host } = window.location
    return url + addParam('redirect_uri', `${protocol}//${host}${originUrl}`)
  },
  addCSRFTokenToUrl(url: string) {
    return url + addParam('state', this.generateCSRFToken())
  },
  generateCSRFToken(): string {
    const token = Math.random().toString(36).substr(2) + Math.random().toString(36).substr(2)
    sessionStorage.setItem(CSRF_TOKEN_KEY, token)
    return token
  },
  validateAndConsumeCSRFToken(token: string): boolean {
    const savedToken = sessionStorage.getItem(CSRF_TOKEN_KEY)
    sessionStorage.removeItem(CSRF_TOKEN_KEY) // Remove the token so it can be used only once
    return token === savedToken
  },
}

export const parsePropsFromQueryParams = (queryParams: string): MyPayNowProps => {
  const paramArray = (queryParams && queryParams.replace(/^\?/, '').split('&')) || []
  const authorizationParams = paramArray.reduce((paramAcc, paramString) => {
    const paramKeyValue = paramString.split('=')
    return paramKeyValue.length >= 2
      ? Object.assign({}, paramAcc, { [decodeURI(paramKeyValue[0])]: decodeURI(paramKeyValue[1]) })
      : paramAcc
  }, {})

  if ((authorizationParams as PayNowAuthorizationFailure).error) {
    return { authorizationFailure: authorizationParams as PayNowAuthorizationFailure }
  }

  if ((authorizationParams as PayNowAuthorizationSucess).code) {
    return { authorizationSuccess: authorizationParams as PayNowAuthorizationSucess }
  }
  return {}
}

function mapStateToStripeParams(state: StateInterface) {
  return {
    company: state.company,
    name: state.settings.values.company.tradeNames[0].name,
    url: state.settings.values.company.tradeNames[0].address.www,
    city: state.settings.values.company.tradeNames[0].address.city,
    zip: state.settings.values.company.tradeNames[0].address.pobox,
    address: state.settings.values.company.tradeNames[0].address.streetAddress1,
    firstName: state.settings.values.company.tradeNames[0].contact.name.first,
    lastName: state.settings.values.company.tradeNames[0].contact.name.last,
  }
}

function addParam(key, value) {
  return `&${key}=${encodeURIComponent(value)}`
}
